import { render, staticRenderFns } from "./UploadSelect.vue?vue&type=template&id=258a3bd8"
import script from "./UploadSelect.vue?vue&type=script&lang=js"
export * from "./UploadSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports